/**
 * Zahlen so, wie der Berater sie liest. Dieselbe Schreibweise wie belegText
 * auf dem Server (ki-lauf.ts): ab einer Million in Millionen, sonst in
 * Tausend, eine Nachkommastelle.
 */

const eineStelle = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
const ganz = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 })

/** Echtes Minuszeichen statt Bindestrich: steht in Spalten sauber unter dem Plus. */
const vorzeichen = (x: number): string => (x < 0 ? '−' : '')

export function euro(cent: number | null): string {
  if (cent === null) return '–'
  const b = Math.abs(cent)
  return `${vorzeichen(cent)}${b >= 100_000_000 ? `${eineStelle.format(b / 100_000_000)} Mio. €` : `${eineStelle.format(b / 100_000)} Tsd. €`}`
}

/** Ein grosser Betrag als Kachelwert: ganze Tausend. */
export function euroGanz(cent: number | null): string {
  return cent === null ? '–' : `${vorzeichen(cent)}${ganz.format(Math.abs(cent) / 100_000)} Tsd. €`
}

/** Beschriftung einer Achse: kurz, ohne Waehrung. */
export function achse(wert: number, einheit: 'cent' | 'prozent'): string {
  if (einheit === 'prozent') return `${ganz.format(wert)} %`
  const b = Math.abs(wert)
  return `${vorzeichen(wert)}${b >= 100_000_000 ? `${eineStelle.format(b / 100_000_000)} Mio.` : `${ganz.format(b / 100_000)} Tsd.`}`
}

export function prozent(x: number | null): string {
  return x === null ? '–' : `${vorzeichen(x)}${eineStelle.format(Math.abs(x))} %`
}

/** Veraenderung mit Vorzeichen: "+1,9", "−0,9". */
export function mitVorzeichen(x: number): string {
  return `${x > 0 ? '+' : x < 0 ? '−' : ''}${eineStelle.format(Math.abs(x))}`
}

export function wertMitEinheit(w: number | null, einheit: 'cent' | 'prozent'): string {
  return einheit === 'cent' ? euro(w) : prozent(w)
}
